import { motion, useReducedMotion } from 'framer-motion';

const appleEase: [number, number, number, number] = [0.22, 1, 0.36, 1];

const wordVariants = {
  hidden: { opacity: 0, y: 20, filter: 'blur(4px)' },
  visible: { opacity: 1, y: 0, filter: 'blur(0px)', transition: { duration: 0.55, ease: appleEase } },
};

const plainVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.4 } },
};

interface WordRevealHeadingProps {
  text: string;
  className?: string;
  /** Controlled by the parent's animate state ("hidden" | "visible"). */
  as?: 'h1' | 'h2' | 'h3';
}

/**
 * Headline that reveals word by word with a soft blur-to-sharp finish,
 * matching the hero treatment. Inherits its parent's animation state.
 */
export default function WordRevealHeading({ text, className, as = 'h2' }: WordRevealHeadingProps) {
  const reduceMotion = useReducedMotion();
  const Tag = motion[as];
  const words = text.split(' ');

  if (reduceMotion) {
    return (
      <Tag variants={plainVariants} className={className}>
        {text}
      </Tag>
    );
  }

  return (
    <Tag
      variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.055 } } }}
      className={className}
    >
      <span className="sr-only">{text}</span>
      <span aria-hidden="true">
        {words.map((word, i) => (
          <motion.span key={`${word}-${i}`} variants={wordVariants} className="inline-block mr-[0.25em]">
            {word}
          </motion.span>
        ))}
      </span>
    </Tag>
  );
}
